import * as R from 'ramda'
import {
  COMPLETE_STEPS,
  SET_STEPS,
  LOAD_COMPLETE_STEPS,
} from '../actions/setupSteps.actions'
import { SetupStepTypes } from 'commons/useSetupSteps'

const setupSteps = {
  version: 1,
  isInitialized: false,
  steps: [
    {
      id: SetupStepTypes.CONFIRM_EMAIL,
      icon: 'email',
      title: 'welcome.steps.title1',
      subtitle: {
        pending: 'welcome.steps.subtitle1.pending',
        completed: 'welcome.steps.subtitle1.completed',
      },
    },
    {
      id: SetupStepTypes.COMPLETE_PROFILE,
      icon: 'business',
      title: 'welcome.steps.title2',
      subtitle: {
        pending: 'welcome.steps.subtitle2.pending',
        completed: 'welcome.steps.subtitle2.completed',
      },
    },
    {
      id: SetupStepTypes.CREATE_GROUP,
      icon: 'group',
      title: 'welcome.steps.title3',
      subtitle: {
        pending: 'welcome.steps.subtitle3.pending',
        completed: 'welcome.steps.subtitle3.completed',
      },
    },
    {
      id: SetupStepTypes.BUILD_SUBSCRIBER,
      icon: 'swap_vert',
      title: 'welcome.steps.title4',
      subtitle: {
        pending: 'welcome.steps.subtitle4.pending',
        completed: 'welcome.steps.subtitle4.completed',
      },
    },
    {
      id: SetupStepTypes.INVITE_TEAM,
      icon: 'message',
      title: 'welcome.steps.title5',
      subtitle: {
        pending: 'welcome.steps.subtitle5.pending',
        completed: 'welcome.steps.subtitle5.completed',
      },
    },
    {
      id: SetupStepTypes.INVITE_SUBSCRIBER,
      icon: 'folder_special',
      title: 'welcome.steps.title6',
      subtitle: {
        pending: 'welcome.steps.subtitle6.pending',
        completed: 'welcome.steps.subtitle6.completed',
      },
    },
    {
      id: SetupStepTypes.CREATE_INITIAL_NOTIFICATION,
      icon: 'notification_important',
      title: 'welcome.steps.title7',
      subtitle: {
        pending: 'welcome.steps.subtitle7.pending',
        completed: 'welcome.steps.subtitle7.completed',
      },
    },
    {
      id: SetupStepTypes.NOTIFICATION_SEND,
      icon: 'send',
      title: 'welcome.steps.title8',
      subtitle: {
        pending: 'welcome.steps.subtitle8.pending',
        completed: 'welcome.steps.subtitle8.completed',
      },
    },
    {
      id: SetupStepTypes.SETUP_BILL_PAY,
      icon: 'credit_card',
      title: 'welcome.steps.title9',
      subtitle: {
        pending: 'welcome.steps.subtitle9.pending',
        completed: 'welcome.steps.subtitle9.completed',
      },
    },
  ],
}

const setupStepsReducer = (state = setupSteps, action) => {
  switch (action.type) {
    case LOAD_COMPLETE_STEPS:
      return R.o(
        R.set(R.lensProp('isInitialized'), true),
        R.over(
          R.lensProp('steps'),
          R.map((step) =>
            R.mergeRight(
              step,
              R.defaultTo(
                { isDone: false },
                R.find(
                  R.eqProps('id', step),
                  R.path(['payload', 'steps'], action),
                ),
              ),
            ),
          ),
        ),
        state,
      )
    case SET_STEPS:
      return state
    case COMPLETE_STEPS:
      return R.over(
        R.lensProp('steps'),
        R.map(
          R.when(
            R.propSatisfies(R.equals(action.id), 'id'),
            R.mergeLeft({ isDone: true }),
          ),
        ),
        state,
      )
    default:
      return state
  }
}

export default setupStepsReducer
